// Produces a REAL pixel-cropped image file -- not a CSS preview trick. Takes
// the pixel crop rect react-easy-crop reports (onCropComplete's 2nd arg) and
// draws exactly that rect onto a canvas at its native resolution, then
// exports it as a new File so the server/Meta never sees the original
// uncropped image when a crop was applied.
function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener("load", () => resolve(img));
    img.addEventListener("error", reject);
    img.setAttribute("crossOrigin", "anonymous");
    img.src = src;
  });
}

export async function getCroppedFile(imageSrc, pixelCrop, fileName, mimeType) {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(pixelCrop.width);
  canvas.height = Math.round(pixelCrop.height);
  const ctx = canvas.getContext("2d");
  ctx.drawImage(
    image,
    pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height,
    0, 0, pixelCrop.width, pixelCrop.height
  );
  const type = mimeType || "image/jpeg";
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, type, 0.92));
  return new File([blob], fileName, { type });
}
